<template>
  <div>
    <div class="item-head">
      <span class="badge badge-pill badge-warning text-capitalize">{{ item.type }}</span>
      <span class="badge badge-pill badge-light">{{ item.id }}</span>
      <label class="mini-check"><input :id="`secure-${item.id}`" type="checkbox" v-model="item.security"> محافظت</label>
      <input type="text" class="form-control title-input" v-model="item.title" placeholder="عنوان">
      <b-icon class="bg-danger p-1 rounded-pill text-white" icon="trash" @click="deleteQuestion()"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "GateInput",
  props: {item: {}},
  methods: {
    deleteQuestion() {
      this.$emit('removeQuestion')
    }
  }
}
</script>

<style scoped>
.item-head { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; }
.item-head .form-control:not(.title-input) { flex: 1 1 140px; }
.mini-check { font-size: 12px; margin: 0; }
</style>
